module.exports = __webpack_public_path__ + "img/3.1af83331.png";